import React, { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import AuthLayout from "src/component/navigation/publicNavbar";

const ForgotPasswordScreen = lazy(
  () => import("src/pages/outerPages/forgot_password/forgotPasswordScreen")
);
const SignUpScreen = lazy(
  () => import("src/pages/outerPages/sign_up/signUpScreen")
);
const LoginScreen = lazy(
  () => import("src/pages/outerPages/login/loginScreen")
);
const HomeScreen = lazy(() => import("src/pages/outerPages/home/home"));

const AuthRoute: React.FC = () => {
  return (
    <AuthLayout>
      <Suspense>
        <Routes>
          <Route path="/login" element={<LoginScreen />} />
          <Route path="/forgot_password" element={<ForgotPasswordScreen />} />
          <Route path="/sign_up" element={<SignUpScreen />} />
          <Route path="/Home" element={<HomeScreen />} />
          <Route path="/" element={<HomeScreen />} />
        </Routes>
      </Suspense>
    </AuthLayout>
  );
};

export default AuthRoute;
